import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { ShieldCheck, Loader2 } from 'lucide-react';
import { Switch } from './ui/switch';
import { Button } from './ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LicenseSettingsCard = () => {
  const [ppl, setPpl] = useState(false);
  const [novex, setNovex] = useState(false);
  const [configured, setConfigured] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let on = true;
    axios.get(`${API}/licensing/settings`).then((r) => {
      if (!on) return;
      setPpl(!!r.data.ppl); setNovex(!!r.data.novex); setConfigured(!!r.data.configured);
    }).catch(() => {}).finally(() => on && setLoading(false));
    return () => { on = false; };
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/licensing/settings`, { ppl, novex });
      setConfigured(true);
      toast.success('Music licences saved — only covered songs will play');
    } catch {
      toast.error('Could not save licences');
    } finally { setSaving(false); }
  };

  return (
    <div className="bg-white/[0.03] border border-white/10 rounded-2xl lg:rounded-3xl p-5 lg:p-6 backdrop-blur-xl" data-testid="license-settings-card">
      <div className="flex items-start gap-3 mb-4">
        <div className="w-10 h-10 rounded-xl bg-[#39FF14]/15 flex items-center justify-center flex-shrink-0">
          <ShieldCheck className="w-5 h-5 text-[#39FF14]" />
        </div>
        <div>
          <h2 className="text-lg font-extrabold text-white tracking-tight" style={{ fontFamily: 'Outfit' }}>Music Licences</h2>
          <p className="text-gray-400 text-xs mt-0.5">We hereby certify we hold the required public performance licenses of the below organizations:</p>
        </div>
      </div>

      {loading ? (
        <div className="py-6 text-center text-gray-500"><Loader2 className="w-5 h-5 animate-spin mx-auto" /></div>
      ) : (
        <>
          <div className="space-y-2">
            <label className="flex items-center justify-between bg-black/30 rounded-xl px-4 py-3 border border-white/5">
              <span><span className="text-white font-semibold">PPL</span><span className="text-gray-500 text-xs ml-2">Phonographic Performance Ltd</span></span>
              <Switch checked={ppl} onCheckedChange={setPpl} data-testid="license-ppl-toggle" />
            </label>
            <label className="flex items-center justify-between bg-black/30 rounded-xl px-4 py-3 border border-white/5">
              <span><span className="text-white font-semibold">Novex</span><span className="text-gray-500 text-xs ml-2">Novex Communications</span></span>
              <Switch checked={novex} onCheckedChange={setNovex} data-testid="license-novex-toggle" />
            </label>
          </div>
          <div className="flex items-center justify-between mt-4">
            <span className="text-[11px] text-gray-500" data-testid="license-status">
              {configured ? 'Enforcement active' : 'Not set up yet — everything plays until you save'}
            </span>
            <Button onClick={save} disabled={saving} className="bg-[#39FF14]/90 hover:bg-[#39FF14] text-black rounded-full px-5 text-xs font-bold tracking-wider" data-testid="license-save">
              {saving ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : null} SAVE LICENCES
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default LicenseSettingsCard;
